import { useMutation, useQuery } from '@tanstack/react-query';
import { useAuth } from '../../contexts/authContext';
import { projectDataClient } from '../../lib/connect/clients';
export function useGrowthHomeWork(lens) {
    const { user } = useAuth();
    return useQuery({
        queryKey: [
            'growth-home-work',
            user?.tenant_id,
            user?.id,
            lens
        ],
        queryFn: ()=>projectDataClient.getGrowthHomeWork({
                lens
            }),
        enabled: !!user?.id,
        retry: false
    });
}
/**
 * GRW-21 `MarkGrowthHomeSeen`: records this visit for the "Changed on your
 * pursuits since …" window. The server debounces (2 hours), so reloading Home
 * keeps the same window. GrowthHomeV2 calls it once per mount.
 */ export function useMarkGrowthHomeSeen() {
    return useMutation({
        mutationFn: ()=>projectDataClient.markGrowthHomeSeen({})
    });
}
